<template>
    <div>
        <release-form-uploader v-for="uploader in releaseFormUploaders"
                               class="d-none"
                               @complete="handleCompletedReleaseForm"
                               @uploading="handleUploadStarted"
                               @error="handleUploadError"
                               :uploader="uploader"/>

        <b-alert :show="error" variant="danger">
            There was an error while uploading your file. Please try again.
        </b-alert>

        <b-row class="align-items-stretch">
            <b-col cols="6" v-for="releaseCategory in categorizedReleaseForms">
                <h6>{{ releaseCategory.name }}</h6>
                <div v-for="form in releaseCategory.items">
                    <b-form-radio v-model="selectedReleaseFormId" :value="form.id" class="d-flex-label">
                        <span class="text-truncate mr-2 flex-shrink-1">
                                {{ form.name }}
                            </span>
                        <b-link :href="form.url" target="_blank">
                            <i class="fas fa-external-link-alt"></i>
                        </b-link>
                    </b-form-radio>
                </div>

                <pulse-loader :loading="uploadRunning(releaseCategory.key)"
                              size="10px"
                              color="#00C0F4"
                              class="my-2"/>
            </b-col>
        </b-row>

        <b-row>
            <b-col cols="6" v-for="releaseCategory in categorizedReleaseForms">
                <b-button variant="primary"
                          class="btn-rounded btn-sm mt-3"
                          @click="addReleaseType(releaseCategory.key)">
                    {{ releaseCategory.new_name }}
                </b-button>
            </b-col>
        </b-row>

        <div class="mt-2" v-if="selectedReleaseFormId">
            <b-link class="font-size-sm" @click="selectedReleaseFormId = null">Clear Selection</b-link>
        </div>
    </div>
</template>

<script>
  import ReleaseFormUploader from './ReleaseFormUploader'
  import PulseLoader from 'vue-spinner/src/PulseLoader';

  export default {
    props: ['initialReleaseForms', 'releaseFormUrl'],

    data: function () {
      return {
        releaseForms: this.initialReleaseForms || [],
        releaseFormUploaders: [],
        releaseRequired: false,
        selectedReleaseFormId: null,
        runningUploaders: [],
        error: false
      }
    },

    watch: {
      selectedReleaseFormId(val) {
        if (val) {
          this.$emit('releaseFormSelected')
        } else {
          this.$emit('releaseFormCleared')
        }
      }
    },

    computed: {
      categorizedReleaseForms: function () {
        return [
          {
            name: 'Model Releases',
            key: 'model_release',
            new_name: 'New Model Release',
            items: this.releaseFormsOfType('model_release')
          }, {
            name: 'Property Releases',
            key: 'property_release',
            new_name: 'New Property Release',
            items: this.releaseFormsOfType('property_release')
          }
        ]
      },

      selectedReleaseForm: function () {
        return this.releaseForms.find(form => form.id === this.selectedReleaseFormId)
      }
    },

    methods: {
      uploadRunning(releaseType) {
        return this.runningUploaders.filter(el => el.releaseType === releaseType).length > 0
      },

      handleCompletedReleaseForm(releaseForm, uploader) {
        this.releaseRequired = true;
        this.releaseForms.push(releaseForm);
        this.selectedReleaseFormId = releaseForm.id

        this.removeUploader(uploader)
        this.$emit('releaseFormsChanged', this.releaseForms)
      },

      handleUploadStarted(file, uploader) {
        this.runningUploaders.push(uploader)
      },

      handleUploadError(error, uploader) {
        this.error = true
        this.removeUploader(uploader)
      },

      removeUploader(uploader) {
        let idx = this.runningUploaders.indexOf(uploader);
        if (idx >= 0) {
          this.runningUploaders.splice(idx, 1);
        }
      },

      releaseFormsOfType: function (type) {
        if (!this.releaseForms) return null;
        return this.releaseForms.filter(f => f.release_type === type)
      },

      addReleaseType: function (releaseType) {
        this.error = false

        this.releaseFormUploaders.push({
          asset: this.asset,
          url: this.releaseFormUrl,
          releaseType: releaseType
        })
      }
    },

    components: {ReleaseFormUploader, PulseLoader}
  }
</script>